import {Label} from '@primer/react'

import labelStyles from '../EntryStatusLabel.module.css'
import {EffectiveEntryStatus} from '../../../../helpers/effective-entry-status'
import type {EffectiveEntryStatus as EffectiveEntryStatusType} from '../../../../helpers/effective-entry-status'

export function NotReadyStatusLabel({status}: {status: EffectiveEntryStatusType}) {
  if (status !== EffectiveEntryStatus.NotReady) return null

  return (
    <Label variant="attention" className={labelStyles.solid}>
      Not ready
    </Label>
  )
}
